import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export const getPaymentMethods = (accountNumber) => {
  return axios.post(`${apiUrl}adyen/payment-method`, {
    data: {
      type: 'payment-method',
      attributes: {
        amount: 100,
        channel: 'web',
        account_number: accountNumber,
      },
      links: null,
    },
  }).then((res) => (res)).catch((err) => (err))
}

export const removeAdyenCard = (storedPaymentMethodId, accountNumber) => {
  return axios.post(`${apiUrl}adyen/payment/remove-payment-details`, {
    data: {
      type: 'remove-adyen-details',
      attributes: {
        shopperReference: accountNumber,
        recurringDetailReference: storedPaymentMethodId,
      },
      links: null,
    },
  }).then((res) => (res))
}


/** WEBPACK FOOTER **
 ** ./src/services/adyenService.js
 **/